import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from '../../../../../App';
import { GlobalLoading, showLoading } from 'react-global-loading';
import titlesData from '../../../../../titles.json'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../.././../../assets/Messages.json';
import { generateExcelIIPTopFiveReport } from '../../ExportIIPExcel';
import { useNavigate } from "react-router-dom";

import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../../Constant';
import iipTitleData from '../../../../../iip.json';

const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTH_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const Top5IndexReport = () => {
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const [isDivision, setIsDivision] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(''); // default: Select month
  const [selectedYear, setSelectedYear] = useState(''); // default: Select year
  const storedLanguage = localStorage.getItem('language');
  
  const navigate = useNavigate();
  const config = getAuthHeaders();
  useEffect(() => {

    //Get all Months data    
    const getMonthsList = (e) => {
      showLoading(true)
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    }



    const getYearList = () => {
      const startYear = 2014;
      const endYear = new Date().getFullYear(); // current year pehle (descending)
      const yearsArray = [];
      for (let year = endYear; year >= startYear; year--) {
        yearsArray.push(year);
      }
      setYears(yearsArray);
    };

    getYearList();
    getMonthsList();



  }, []);


  const formatCellValue = (val) => {
    if (val === '' || val == null) return '';
    const n = Number(val);
    return isNaN(n) ? String(val) : n.toFixed(2);
  };

  const mergeReportData = (annualList = [], previousMonthList = [], previousYearList = []) => {
    const byNic = {};
    [...annualList, ...previousMonthList, ...previousYearList].forEach((item) => {
      const nic = item.NIC_2D;
      if (!byNic[nic]) {
        byNic[nic] = { nic2d: nic, itemDescription: item.itemDescription || '', value: '', previousYearValue: '', previousMonthValue: '' };
      } else if (!byNic[nic].itemDescription && item.itemDescription) {
        byNic[nic].itemDescription = item.itemDescription;
      }
    });
    annualList.forEach((item) => {
      if (byNic[item.NIC_2D]) byNic[item.NIC_2D].value = item.index;
    });
    previousYearList.forEach((item) => {
      if (byNic[item.NIC_2D]) byNic[item.NIC_2D].previousYearValue = item.index;
    });
    previousMonthList.forEach((item) => {
      if (byNic[item.NIC_2D]) byNic[item.NIC_2D].previousMonthValue = item.index;
    });
    const order = annualList.map((x) => x.NIC_2D);
    const rest = Object.keys(byNic).filter((nic) => !order.includes(nic));
    return [...order, ...rest].map((nic) => byNic[nic]);
  };

  const handleGetReport = () => {
    if (selectedMonth === '' || selectedYear === '') {
      toast.error('Please select month and year', messages.COLOR_RED);
      return;
    }
    const payload = { month: MONTH_SHORT[Number(selectedMonth)], year: String(selectedYear) };
    showLoading(true);

    axios
      .post(`${API_URL}api/iipReports/top5IndexReport`, payload, config)
      .then((response) => {
        const data = response.data.data || {};
        const annualList = data.AnnualProductionDataList || [];
        const previousMonthList = data.PreviousMonthDataList || [];
        const previousYearList = data.PreviousYearDataList || [];
        const merged = mergeReportData(annualList, previousMonthList, previousYearList);

        const dateStr = `${payload.month}-${payload.year}`;
        const valueColumnHeader = `${payload.month} ${payload.year}`;
        const prevYear = Number(payload.year) - 1;
        const previousYearValueColumnHeader = `${payload.month} ${prevYear}`; // same month, 1 saal pehle (e.g. JAN 2025)
        const prevMonthIndex = Number(selectedMonth) === 0 ? 11 : Number(selectedMonth) - 1;
        const prevMonthYear = Number(selectedMonth) === 0 ? Number(payload.year) - 1 : Number(payload.year);
        const previousMonthValueColumnHeader = `${MONTH_SHORT[prevMonthIndex]} ${prevMonthYear}`; // previous month (e.g. DEC 2025)
        const excelFileName = `Top5IndexReport(${dateStr})`;
        const excelObjectData = {
          fileName: excelFileName,
          reportType: excelFileName,
          fileType: 'xls',
          sheetName: 'IIP_Top5IndexReport',
          firstRowMergeCells: 'A1:E1',
          firstRowExportDate: 'COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P ',
          firstRowCellNumber: 12,
          secondRowMergeCells: 'A2:E2',
          secondRowText: ' Top 5 Index ',
          fromDate: dateStr,
          toDate: dateStr,
          headerEnglishColumns: ['item', 'Item Name', valueColumnHeader, previousMonthValueColumnHeader, previousYearValueColumnHeader ],
          headerHindiColumns: []
        };
        excelObjectData.excelRowData = merged.map((row) => [
          row.nic2d,
          row.itemDescription,
          formatCellValue(row.value),
          formatCellValue(row.previousMonthValue),
          formatCellValue(row.previousYearValue)
        ]);

        generateExcelIIPTopFiveReport(excelObjectData);
        showLoading(false);
      })
      .catch((error) => {
        console.error('API Error:', error);
        toast.error('Failed to load report.', messages.COLOR_RED);
        showLoading(false);
      });
  };
  


  return (
    <>
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                 <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.TOP_5_INDEX_REPORT : iipTitleData.en.TOP_5_INDEX_REPORT }} />
              </h4>
              <div className="row align-items-center">
                {isDivision && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
                )}



                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Month</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(Number(e.target.value))}
                  >
                    <option value="">Select month</option>
                    {MONTH_NAMES.map((name, index) => (
                      <option key={index} value={index}>{name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Year</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                  >
                    <option value="">Select year</option>
                    {years.length > 0 ? years.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    )) : (
                      <option value={selectedYear}>{selectedYear}</option>
                    )}
                  </select>
                </div>


                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGetReport} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Top5IndexReport